import React, { useState, useEffect } from "react";
import "./styles.scss";

import Checkbox from "../../common/checkbox";
import { ReactComponent as Backbtn } from "../../assets/icons/backbtn.svg";
import { useNavigate } from "react-router-dom";
import { postBundleLayout } from "../../store/homeAction/action";
import { useStateValue } from "../../store/index";

const Layouts = () => {
  const Navigate = useNavigate();
  const [{ bundleLayout }, dispatch] = useStateValue();
  const [selectedItem, setSelectedItem] = useState(
    JSON.parse(sessionStorage.getItem("choose_layout"))?.term_id
  );

  useEffect(() => {
    // if (Object.keys(bundleLayout).length == 0) {
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    let payload = JSON.parse(sessionStorage.getItem("bundle_layout"));
    postBundleLayout((res, error) => {
      dispatch({
        type: "SET_BUNDLE_LAYOUT",
        data: res,
      });

      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
      if (error) {
        dispatch({
          type: "SET_ALERT_MESSAGE",
          value: true,
          data: {
            severity: "error",
            message: "Something went wrong, Please try again.",
          },
        });
      }
    }, payload);
    // }
  }, []);

  const handleNavigate = (data) => {
    setSelectedItem(data?.id);
    sessionStorage.setItem("choose_layout", JSON.stringify({ ...data?.item }));
    Navigate(`${process.env.REACT_APP_BASE}/bundle`);
  };
  return (
    <div className="layout-container">
      <Backbtn onClick={() => Navigate(-1)} className="back-btn" />
      <h3>{bundleLayout?.layout_popup_title}</h3>
      <p>{bundleLayout?.layout_popup_description}</p>
      <Checkbox
        data={bundleLayout?.layout}
        onClick={(data) => handleNavigate(data)}
        id={selectedItem}
      />
    </div>
  );
};

export default Layouts;
